import { forwardRef } from 'react';
import { cx } from '@linaria/atomic';
import { Button, ButtonProps } from '@frontend/design-system';
import { SettingsBulkActionButtonStyles } from './settings-bulk-action-button.styles';

type SettingsBulkActionButtonProps = Omit<ButtonProps, 'variant' | 'size'>;

export const SettingsBulkActionButton = forwardRef<HTMLButtonElement, SettingsBulkActionButtonProps>((props, ref) => {
  return (
    <Button
      ref={ref}
      size='small'
      {...props}
      className={cx(SettingsBulkActionButtonStyles.componentButtonStyle1, props.className)}
      variant='tertiary'
    />
  );
});
SettingsBulkActionButton.displayName = 'SettingsBulkActionButton';
